'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'star-half-stroke';
var width = 576;
var height = 512;
var aliases = ["star-half-alt"];
var unicode = 'f5c0';
var svgPathData = ['M288.1-32c0 37.3 0 74.7 0 112 12.7 24.8 25.3 49.6 38 74.4 9.3 18.2 26.7 30.9 47 34.1l82.5 13.1-59 59.1c-14.5 14.5-21.1 35-17.9 55.2l13 82.5-74.4-37.9c-9.1-4.6-19.1-7-29-7 0 21.3 0 42.7 0 64 48.1 24.5 96.2 48.9 144.3 73.4 8 4.1 17.7 3.3 25-2s11-14.2 9.6-23.2L441.7 305.9 556.1 191.4c6.4-6.4 8.6-15.8 5.8-24.4s-10.1-14.9-19.1-16.3L383 125.3 309.5-18.9c-4.1-8-12.4-13.1-21.4-13.1z', 'M288.1-32l0 0c-9 0-17.3 5.1-21.4 13.1L193.1 125.3 33.2 150.7c-8.9 1.4-16.3 7.7-19.1 16.3s-.5 18 5.8 24.4l114.4 114.5-25.2 159.9c-1.4 8.9 2.3 17.9 9.6 23.2s16.9 6.1 25 2l144.3-73.4 0 0 0-64 0 0 0-273.6 0 0 0-112z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStarHalfStroke = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;